export const twilioErrorCodes = [20101];

export const twilioErrorMessages = {
  "20101": "視像面試中斷，請重新連接。",
};
